import { render, staticRenderFns } from "./AddTags.vue?vue&type=template&id=766b6f82&scoped=true"
import script from "./AddTags.vue?vue&type=script&lang=js"
export * from "./AddTags.vue?vue&type=script&lang=js"
import style0 from "./AddTags.vue?vue&type=style&index=0&id=766b6f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766b6f82",
  null
  
)

export default component.exports